import { Component, Input, isDevMode } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/utilities/auth.service';
import { ScreenSizeService } from 'src/app/services/utilities/screen-size.service';
import { TranslationService } from 'src/app/services/utilities/translation.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SideBarComponent {
  isConnectedUserAdmin: boolean = false;
  hoveringOverLink: boolean = false;
  logoURL: string = 'assets/img/logo.png';
  logoSize: string = 'h-12';
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private translationService: TranslationService,
    private screenSizeService: ScreenSizeService,
    private uiStateService: UiStateService
  ) {}
  // authenticatedUser!: any;
  accreditedGroups: any[] = [];
  env: string = environment.env;
  dropDown: boolean = false;
  auth!: any;
  screenWidth: number = 0;
  screenHeight: number = 0;
  currentRootGroup:any
  activeRoute: string = '';
  subscriptions:Subscription[] = [];
  ngOnInit() {
    this.dropDown = window.location.href.includes(window.location.origin+'/dashboard');
    this.activeRoute = this.route.snapshot.routeConfig?.path || 'Unknown';
    // console.log("this.activeRoute",this.activeRoute,this.route.snapshot.routeConfig)
    this.subscriptions.push(this.uiStateService.currentRootGroup$.subscribe((group:any) =>{
      this.currentRootGroup=group
      // console.log("current group root is ",this.currentRootGroup)
    }));
    this.subscriptions.push(this.authService.loadCurrentUser().subscribe((res:any)=>{
      this.auth=res.data
      // console.log("this.auth",this.auth)
    }))
    
    // if (isSagamm ??) {
    this.logoURL = 'assets/img/logo-sagamm.png';
    this.logoSize = 'h-36';

    // }
    if (this.router.url.includes('dashboard')) {
      this.dropDown = true;
    }    

    this.subscriptions.push(this.screenSizeService.screenWidth$.subscribe(
      (width: number) => (this.screenWidth = width)
    ));
    this.subscriptions.push(this.screenSizeService.screenHeight$.subscribe(
      (height: number) => (this.screenHeight = height)
    ));
  }

  isDashBoardActiveRoute(){

  }

  getAccreditedGroups() {
    if (!this.auth || !this.auth.accreditations) {
      // console.error("Authenticated user or accreditations are not available.");
      return [];
    }
    const accg: any = [];
    for (let accreditation of this.auth.accreditations) {
      // Debug.log("acc",accreditation)
      const acc_permissions = [];
      for (let permission of accreditation.profile.permissions) {
        // Debug.log(permission.action,permission.ProfilePermission.value)
        acc_permissions.push({
          action: permission.action,
          value: permission.ProfilePermission.value,
        });
      }
      accg.push({ group: accreditation.group, profile: accreditation.profile });
    }

    return accg;
  }

  getTranslation(key: string): string {
    return this.translationService.t(key);
  }

  openDropDown() {
    if (this.auth?.UI['dashboard']) this.dropDown = !this.dropDown;
  }
  hoveredIcon: string | null = null;

  onHover(icon: string | null) {
    this.hoveredIcon = icon;
  }

  getUserRole(){
    return this.authService.loadUserfromLs()?.isAdmin? "Admin":"User"
  }
  getUserUIAccess(mapName:string){
    const user = {...this.authService.loadUserfromLs()}
    
    if(user.UI){
      return user.UI[mapName]
    }
    return false
  }
  getSideBarLogo(){
    // console.log(this.currentRootGroup)
    return this.currentRootGroup?.hasSagammLogo?this.logoURL:"assets/img/logo.png"
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
